import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { cn } from "cn";

export interface RefreshErrorBannerProps {
    message: string;
    className?: string;
}

export function RefreshErrorBanner({ message, className }: RefreshErrorBannerProps) {
    return (
        <output className={cn("border-danger/60 bg-danger/10 text-danger mb-4 flex items-center gap-2 rounded-xl border px-4 py-3 text-sm", className)}>
            {/* intent-ui-deviation: hand-rolled <output> banner rather than Intent UI <Note> -- <output> carries an
                implicit polite role="status" (the deliberate distinction from the assertive ErrorState; see the
                component doc above), and this stays collection-specific to the keepPreviousData stale-refetch cue. */}
            <ExclamationTriangleIcon aria-hidden="true" className="size-5 shrink-0" />
            <span>{message}</span>
        </output>
    );
}
